/**
 * WordPress dependencies
 */
import { createContext } from '@wordpress/element';
export var Context = createContext(false);
var Consumer = Context.Consumer,
    Provider = Context.Provider;
export var AsyncModeConsumer = Consumer;
export default Provider;
//# sourceMappingURL=context.js.map